export const KEY_TAB = 9
export const KEY_ESC = 27
export const KEY_ARROW_LEFT = 37
export const KEY_ARROW_UP = 38
export const KEY_ARROW_RIGHT = 39
export const KEY_ARROW_DOWN = 40
